<script setup>
import Icon from './Icon.vue';
import Tooltip from './Tooltip.vue';

import { ANALYTICS_HELP } from '@/content/analyticsHelp.js';

defineOptions({ name: 'DsContextHelp' });
const props = defineProps({ helpKey: { type: String, required: true } });
</script>

<template>
  <Tooltip v-if="ANALYTICS_HELP[props.helpKey]">
    <template #trigger>
      <button
        class="context-help"
        type="button"
        :aria-label="`About ${props.helpKey}`"
      >
        <Icon
          name="info"
          :size="14"
        />
      </button>
    </template>
    <template #content>
      {{ ANALYTICS_HELP[props.helpKey] }}
    </template>
  </Tooltip>
</template>

<style scoped>
.context-help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--control-sm);
  height: var(--control-sm);
  padding: 0;
  border: 0;
  border-radius: var(--radius-sm);
  color: var(--fg-secondary);
  background: transparent;
  cursor: help;
}

.context-help:hover,
.context-help:focus-visible {
  color: var(--fg-primary);
  background: var(--bg-muted);
}
</style>
